import {inject, Injectable} from '@angular/core';
import {environment} from '../../environments/environment';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {LoginUserCommand} from '../models/users/loginUserCommand';
import {User} from '../models/users/user';
import {LoginResult} from '../models/users/loginResult';

@Injectable({
  providedIn: 'root',
})
export class UserApiService {
  private readonly url = `${environment.apiUrl}/user`;
  private readonly httpClient = inject(HttpClient);

  list(): Observable<User[]> {
    return this.httpClient.get<User[]>(this.url);
  }

  update(id: string, isAdmin: boolean): Observable<void> {
    return this.httpClient.put<void>(`${this.url}/${id}?isAdmin=${isAdmin}`, null);
  }

  add(loginUserCommand: LoginUserCommand): Observable<LoginResult> {
    return this.httpClient.post<LoginResult>(this.url, loginUserCommand);
  }

  isAdmin(id: string): Observable<boolean> {
    return this.httpClient.get<boolean>(`${this.url}/admin/${id}`);
  }
}
